import { render, staticRenderFns } from "./lamp-on.vue?vue&type=template&id=218cc818&"
import script from "./lamp-on.vue?vue&type=script&lang=js&"
export * from "./lamp-on.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('218cc818')) {
      api.createRecord('218cc818', component.options)
    } else {
      api.reload('218cc818', component.options)
    }
    module.hot.accept("./lamp-on.vue?vue&type=template&id=218cc818&", function () {
      api.rerender('218cc818', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/lamp-on.vue"
export default component.exports